import { TRACKING_EVENTS } from '../core/constants';
import { trackEvent } from '../core/tracker';

export const trackCreateReport = (orientation: 'portrait' | 'landscape' | 'dashboard', isConsolidation?: boolean) => {
  trackEvent(TRACKING_EVENTS.CREATE_ANY_REPORT_OR_DASHBOARD);

  if (isConsolidation) {
    trackEvent(TRACKING_EVENTS.CREATE_CONSOLIDATION_REPORT);
  } else {
    if (orientation === 'portrait') {
      trackEvent(TRACKING_EVENTS.CREATE_PORTRAIT_REPORT);
    } else if (orientation === 'landscape') {
      trackEvent(TRACKING_EVENTS.CREATE_LANDSCAPE_REPORT);
    } else {
      trackEvent(TRACKING_EVENTS.CREATE_DASHBOARD);
    }
  }
};
